import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Hero from "./sections/Hero";
import Credentials from "./sections/Credentials";
import About from "./sections/About";
import Platform from "./sections/Platform";
import Hardware from "./sections/Hardware";
import Industries from "./sections/Industries";
import CaseStudy from "./sections/CaseStudy";
import Services from "./sections/Services";
import Contact from "./sections/Contact";
import { NAV } from "../data/content";

const useActiveSection = (ids) => {
  const [active, setActive] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px" }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [ids]);

  return active;
};

const SECTION_IDS = NAV.map((n) => n.id);

const Home = () => {
  const activeSection = useActiveSection(SECTION_IDS);

  return (
    <>
      <Header activeSection={activeSection} />
      <main id="main">
        <Hero />
        <Credentials />
        <About />
        <Platform />
        <Hardware />
        <Industries />
        <CaseStudy />
        <Services />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
